import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-object-ratings/rent-objects/${formData.rentObjectId}`, formData);
  },
  async findAll(formData) {
    return axios.get(`/rent-object-ratings/rent-objects/${formData.rentObjectId}`);
  },
  async update(formData) {
    return axios.put('/rent-object-ratings', formData);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-ratings/${id}`);
  },
};
